<template>
  <div class="text-md font-medium leading-5 text-slate-500 md:text-sm md:leading-4">
    <slot />
  </div>
</template>
